// extracted by mini-css-extract-plugin
export default {"icons":"Icons_icons__bU6rM","emailButton":"Icons_emailButton__zlUb1"};